<template>
	<div class="acupuncture">
		<v-row no-gutters align="center" class="mb-5">
			<v-btn color="primary" fab x-small @click="newTreatment = false; newTreatmentSearch = !newTreatmentSearch">
				<v-icon>add</v-icon>
			</v-btn>
			<v-btn color="primary" class="ml-2" fab x-small @click="newTreatmentSearch = false; newTreatment = !newTreatment" :disabled="!$store.getters.hasModule('mtc')">
				<v-icon v-if="newTreatment">mdi-chevron-up</v-icon>
				<v-icon v-else>mdi-chevron-down</v-icon>
			</v-btn>
			<v-btn :color="appointment.acu_notes ? 'green' : 'primary'" fab x-small class="ml-2" @click="showNotes = true">
				<v-icon small>mdi-note-outline</v-icon>
				<v-dialog v-model="showNotes" max-width="65%">
					<v-card>
						<v-card-title class="title primary--text mb-2 secondary">
							<translate>Acupuncture</translate>
							<span class="mx-2">-</span>
							<translate>Notes</translate>
						</v-card-title>
						<v-card-text>
							<v-row no-gutters class="mt-3">
								<v-col cols="12" sm="12">
									<v-textarea
										@blur="$emit('save-notes', false)"
										:label="$gettext('Notes')"
										filled
										hide-details
										v-model="appointment.acu_notes"
										auto-grow
									></v-textarea>
								</v-col>
							</v-row>
						</v-card-text>
						<v-divider></v-divider>
						<v-card-actions>
							<v-spacer></v-spacer>
							<v-btn color="primary darken-1" text @click="showNotes = false">
								<translate>Close</translate>
							</v-btn>
						</v-card-actions>
					</v-card>
				</v-dialog>
			</v-btn>
			<v-btn color="primary" fab x-small class="ml-2" @click="graphicMode = true" disabled>
				<v-icon>mdi-pencil</v-icon>
			</v-btn>
			<AcupunctureGraphicMode :show="graphicMode" @close="graphicMode = false" :auricular="false" />
			<v-spacer></v-spacer>
			<v-btn color="primary" small class="ml-2" @click="showRecommendations = true">
				<translate>Recommendations</translate>
			</v-btn>
				<AcupunctureRecommendations
					v-model="showRecommendations"
					@hide-recommendations="hideRecommendations"
					@add-recommendations="addRecommendations"
				/>
		</v-row>
		<v-row v-if="newTreatmentSearch" no-gutters class="mb-5 px-3">
			<v-col cols="12">
				<SearchPoints @add-point="addPoint" :auricular="false" />
			</v-col>
		</v-row>
		<AcupunctureSelector v-if="newTreatment" />
		<v-row no-gutters>
			<v-col cols="12">
				<p v-if="acuPoints.length == 0 && (ashiPoints == null || ashiPoints == '')" class="font-weight-thin ml-2" v-translate>No prescription.</p>
				<template v-else>
					<template v-if="ashiPoints != null && ashiPoints != ''">
						<span class="primary--text font-weight-medium" v-translate>Ashi Points</span><span class="font-weight-light ml-2">{{ashiPoints}}</span>
					</template>
					<AcupunctureGrid v-if="acuPoints.length > 0" :acuPoints="acuPoints" @remove-point="removePoint" />
				</template>
			</v-col>
		</v-row>
	</div>
</template>

<script>
import AcupunctureRecommendations from "@/components/appointment/treatments/tcm/AcupunctureRecommendations.vue";
import AcupunctureGrid from "@/components/appointment/treatments/tcm/acupuncture/AcupunctureGrid.vue";
import AcupunctureGraphicMode from "@/components/appointment/treatments/tcm/acupuncture/AcupunctureGraphicMode.vue";
import AcupunctureSelector from "@/components/appointment/treatments/tcm/acupuncture/AcupunctureSelector.vue";
import SearchPoints from "@/components/appointment/treatments/tcm/acupuncture/SearchPoints.vue";

export default {
	name: "Acupuncture",
	props: {
		appointment: {},
		openPad: {
			default: false
		}
	},
	components: {
		AcupunctureRecommendations,
		AcupunctureGraphicMode,
		AcupunctureGrid,
		AcupunctureSelector,
		SearchPoints
	},
	data: () => ({
		newTreatmentSearch: false,
		newTreatment: false,
		showNotes: false,
		showRecommendations: false,
		graphicMode: false
	}),
	methods: {
		hideRecommendations() {
			this.showRecommendations = false;
		},
		addRecommendations(points) {
			let ids = points.map(p => p.id);
			let data = {
				appointment: this.$route.params.aid,
				op: "add_points",
				ids: ids,
				technics: [1]
			}
			this.$store.dispatch("ADD_POINTS", data);
		},
		addPoint(point) {
			let data = {
				appointment: this.$route.params.aid,
				op: "add_points",
				ids: [point.id],
				technics: [1]
			}
			this.$store.dispatch("ADD_POINTS", data);
		},
		removePoint(point) {
			let data = {
				appointment: this.$route.params.aid,
				op: "remove_point",
				id: point.id
			}
			this.$store.dispatch("REMOVE_POINT", data);
		}
	},
	computed: {
		acuPoints() {
			return this.$store.getters.acuPoints(false);
		},
		ashiPoints() {
			return this.$store.getters.ashiPoints;
		}
	},
	mounted() {
		if(this.openPad) this.newTreatment = true;
	}
};
</script>